import { useCallback, useReducer } from 'react'
import { useNavigate, useLocation } from 'react-router-dom'
import { supervisionActions, supervisionInitialState, supervisionReducer } from '../reducers'
import { useAppSupervisionCalls } from './supervision-calls.hook'
import { parse } from 'qs'
import { DEFAULT_QUERY } from '../constants'

export const useSupervisionReducer = () => {
  const [state, dispatch] = useReducer(supervisionReducer, supervisionInitialState)
  const { getSupervisionApps, putSupervisionApp, assignTasksCall } = useAppSupervisionCalls()
  const navigate = useNavigate()
  const { search } = useLocation() //Use strings and not objects to trigger useEffects a minimum ammount of times

  const supervisionLoad = useCallback(
    (search) => {
      const config = { params: search }
      dispatch({
        type: supervisionActions.SUPERVISION_LOAD,
      })
      return getSupervisionApps(config)
        .then(({ data }) => {
          if (data) {
            dispatch({
              type: supervisionActions.SET_SUPERVISION_DATA,
              payload: {
                data: data['tareas'] || [],
                search: search,
                pagination: {
                  total_paginas: data['total_paginas'] || 0,
                  total_solicitudes: data['total_tareas'] || 0,
                },
              },
            })
          }
          return data
        })
        .catch((error) => {
          dispatch({
            type: supervisionActions.SUPERVISION_FAILURE,
          })
          throw error
        })
    },
    [dispatch, getSupervisionApps] // eslint-disable-line react-hooks/exhaustive-deps
  )

  const supervisionSelect = useCallback(
    (id, type, document) => {
      if (document === 'DE') {
        const remainingPathname = document ? '/' + document : ''
        navigate(id ? '/supervision/' + id + remainingPathname : '/supervision')
      } else {
        const remainingPathname = type ? '/' + type : ''
        const pathname = id ? '/supervision/' + id + remainingPathname : '/supervision'
        navigate(`${pathname}${search}`)
      }
    },
    [search, navigate]
  )

  const supervisionUpdateApplication = useCallback(
    (id, updatedValues) =>
      new Promise((resolve, reject) => {
        dispatch({
          type: supervisionActions.SUPERVISION_LOAD,
        })
        putSupervisionApp(id, updatedValues)
          .then(({ data }) => {
            dispatch({
              type: supervisionActions.UPDATE_SUPERVISED_APPLICATION,
              payload: updatedValues,
            })
            return data
          })
          .then((data) => resolve(data))
          .catch((error) => {
            dispatch({
              type: supervisionActions.SUPERVISION_FAILURE,
            })
            return reject(error)
          })
      }),
    [dispatch, putSupervisionApp] // eslint-disable-line react-hooks/exhaustive-deps
  )

  const supervisionTableCheck = useCallback(
    (rows) => {
      dispatch({
        type: supervisionActions.UPDATE_TABLE_SELECTION,
        payload: rows,
      })
    },
    [dispatch] // eslint-disable-line react-hooks/exhaustive-deps
  )

  const assignTasks = useCallback(
    async (tasks) => {
      try {
        await assignTasksCall(tasks)

        supervisionLoad({
          ...DEFAULT_QUERY,
          ...parse(search ? search.split('?')[1] : ''),
        })
      } catch (error) {
        console.error('Error assigning tasks:', error)
        throw error
      }
    },
    [assignTasksCall, supervisionLoad, search] // eslint-disable-line react-hooks/exhaustive-deps
  )

  return {
    state,
    supervisionLoad,
    supervisionSelect,
    supervisionUpdateApplication,
    supervisionTableCheck,
    assignTasks,
  }
}
